export function PixelSignal({ active = false }: { active?: boolean }) {
  return <span className={`dex-signal ${active ? "dex-signal-active" : ""}`} aria-hidden="true">{Array.from({ length: 20 }, (_, index) => <i key={index} />)}</span>;
}